<template>
        <button
            type="button"
            class="btn btn-pdv btn-pdv-blue mr-1"
            href="javascript: void(0);"
            :disabled="loading"
            @click="handleOk"
        >
            <no-data-export-modal ref="noDataExportModal" />
            <confirmation-form-modal
                ref="confirmationFormModal"
                :title="i18nType"
                :operation="'export'"
            />
            <b-spinner v-if="loading" small class="mr-1"/>
            <i v-else class="fe-download mr-1"></i>
            {{ title === '' ? getI18n('COMMON', 'export') : title }}
        </button>
</template>

<script>
    import ExportJobService from '@src/services/ExportJobService'
    import swalFeedback from '@src/mixins/swalFeedback'
    import ConfirmationFormModal from '@src/components/ConfirmationFormModal'
    import NoDataExportModal from '@/src/components/NoDataExportModal.vue'

    export default {
        components: {
            ConfirmationFormModal,
            NoDataExportModal,
        },
        mixins: [swalFeedback],
        props: {
            title: {
                type: String,
                default: '',
            },
            type: {
                type: String,
                required: true,
            },
            createParameters: {
                type: Function,
                required: true,
            },
            vuetableRef: {
                type: Object,
                required: false,
                default: null
            },
            hasVuetableData: {
                type: Function,
                required: false,
                default: () => true,
            }
        },

        data() {
            return {
                loading: false,
            }
        },
        computed: {
            i18nType() {
                return this.getI18n('EXPORT_JOBS', `TYPES.${this.type}`)
            }
        },
        methods: {
            i18nExportJob(modifier) {
                return this.getI18nModified({
                    prefix: 'EXPORT_JOBS.TITLES',
                    suffix: 'export',
                    modifier: modifier,
                })
            },
            async handleOk() {
                await this.$nextTick();

                const hasDataLoaded = this.vuetableRef ? this.vuetableRef?.vuetable?.$refs?.vuetable?.tableData?.length > 0 : this.hasVuetableData();

                if (!hasDataLoaded) {
                    this.$refs.noDataExportModal.showModal();
                    return;
                }

                if (!this.loading) {
                    this.$refs.confirmationFormModal.showModal(false, this.handleSubmit)
                }
            },
            async handleSubmit(submit) {
                if (!submit) {
                    return
                }

                this.loading = true
                try {
                    let parameters = await this.createParameters()

                    parameters = {
                        ...parameters,
                        export_type: this.type,
                        language: 'pt_BR',
                    }
                    const createResponse = await ExportJobService.create(
                        parameters
                    )
                        .then((response) => response)
                        .catch((error) => {
                            return error
                        })

                    const statusCode = ExportJobService.exportStatus(createResponse)

                    if (statusCode.charAt(0) === '2') {
                        this.$router.push({ name: 'exportJobs', params: { newJobCreated: true } })
                    } else {
                        this.negativeFeedback(
                            this.getI18n('RESPONSES', 'create_not_possible'),
                            ExportJobService.exportErrorMessage(createResponse)
                        )
                    }
                } finally {
                    this.loading = false
                }
            },
        },
    }
</script>
